import zhCN from "./zh-CN.json";
import EN from "./en.json";
import { KV } from '../Constant'

const getLang = (store)=>{
    const lang = store.getKV(KV.LANGUAGE);
    let result
    switch (lang) {
        case 'zh':
            result = zhCN;
            break;
        case 'en':
            result = EN
            break;
        default:
            result = EN
            break;
    }
    return result;
}

export default getLang;

